module.exports = __webpack_public_path__ + "img/freight_yard_bg.7a112f4e.png";